module.exports = __webpack_public_path__ + "static/img/QRcode.1a5d86c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/QRcode.jpg
// module id = Nr7j
// module chunks = 11